<template>
  <div class="content-appmodalcards">
    <div class="col-xs-12 col-sm-10 col-sm-offset-1 offset-sm-1 col-md-8 col-md-offset-2 offset-md-2 mb-15">
      <!-- hidden anchor -->
      <a id="apps" class="anchor" />

      <div class="content-appmodalcards__header">
        <h3>How do these apps offer embedded finance?</h3>
        <p>Click the app icon for details.</p>
      </div>

      <div class="row content-appmodalcards__chart" v-if="appData.length">
        <div class="col-6 col-xs-6 col-md-4 mb-30" v-for="app in appData" :key="app.id">
          <div
            button_name="visualization5"
            class="chart-card dtm-button"
            data-toggle="modal"
            data-target="#appModal"
            @click="handleModal(app)"
          >
            <img
              :src="`/assets/web-resources/techecosystem/fintech/2022/images/${app.app_logo}`"
              :alt="'Logo of ' + app.app_name"
              :id="'app-' + app.id"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="appModal" tabindex="-1" role="dialog" aria-labelledby="appModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button class="close-button" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-nav col-xs-12 col-sm-10 col-sm-offset-1 offset-sm-1 mb-15">
            <button type="button" data-dismiss="modal" aria-label="Close">
              <p class="mb-0"><i class="fas fa-chevron-left" /> Back to report</p>
            </button>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12 col-sm-10 col-sm-offset-1 offset-sm-1 mb-15">
                <h3>{{ selectedApp.app_name }}</h3>
              </div>

              <div class="col-xs-12 col-sm-10 col-sm-offset-1 offset-sm-1 mb-15">
                <div class="modal-section--split modal-section">
                  <div class="flex-20">
                    <p class="font-weight-bold mbtm-5">Year launched</p>
                    <p class="text-legend mb-0">
                      {{ selectedApp.year_launched }}
                    </p>
                  </div>

                  <div class="flex-20">
                    <p class="font-weight-bold mbtm-5">Role</p>
                    <p class="text-legend mb-0">
                      {{ selectedApp.type }}
                    </p>
                  </div>

                  <div class="flex-50">
                    <p class="font-weight-bold mbtm-5">Markets</p>
                    <p class="text-legend mb-0">
                      {{ selectedApp.markets }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-sm-10 col-sm-offset-1 offset-sm-1 mb-15">
                <div class="modal-section--split">
                  <div class="flex-half modal-section">
                    <p class="font-weight-bold mbtm-5">About</p>
                    <p class="text-legend mb-0">
                      {{ selectedApp.about }}
                    </p>
                  </div>

                  <div class="flex-half modal-section">
                    <p class="font-weight-bold mbtm-5">Embedded finance category</p>
                    <p class="text-legend mb-0" v-if="selectedApp.features_BNPL">Buy Now, Pay Later (BNPL)</p>
                    <p class="text-legend mb-0" v-if="selectedApp.features_insurance">Insurance</p>
                    <p class="text-legend mb-0" v-if="selectedApp.features_investments">Investments</p>
                    <p class="text-legend mb-0" v-if="selectedApp.features_lending">Lending</p>
                    <p class="text-legend mb-0" v-if="selectedApp.features_payments">Payments</p>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-sm-10 col-sm-offset-1 offset-sm-1 mb-15">
                <div class="modal-section">
                  <p class="font-weight-bold mbtm-5">What drove them to adopt embedded finance?</p>
                  <p class="text-legend mb-0">
                    {{ selectedApp.adoption }}
                  </p>
                </div>
              </div>

              <div class="col-xs-12 col-sm-10 col-sm-offset-1 offset-sm-1 mb-50">
                <div class="modal-section">
                  <p class="font-weight-bold mbtm-5">Their embedded finance implementation</p>
                  <p class="text-legend mbtm-5">
                    {{ selectedApp.implementation }}
                  </p>
                  <a :href="'https://www.uobgroup.com/uobgroup/url-redirection.page?reURL=' + selectedApp.learnmore_link" target="_blank">Learn more</a>
                </div>
              </div>

              <div class="col-xs-12 col-sm-10 col-sm-offset-1 offset-sm-1 col-md-8 col-md-offset-2 offset-md-2 mb-15">
                <ModalCarousel5 v-if="selectedApp.slides.length === 5" :content="selectedApp.slides" class="mb-50" />
                <ModalCarousel6 v-if="selectedApp.slides.length === 6" :content="selectedApp.slides" class="mb-50" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { csv } from 'd3';
import ModalCarousel5 from '@/components/ui/ModalCarousel5.vue';
import ModalCarousel6 from '@/components/ui/ModalCarousel6.vue';

export default {
  name: 'CardsTop10',
  components: {
    ModalCarousel5,
    ModalCarousel6,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  computed: {
    screenshots() {
      if (this.selectedApp.app_name) {
        const slides = [];
        Array.from(Array(6)).forEach((d, i) => {
          const item = {
            image_url: this.selectedApp[`screenshot_${i + 1}`],
            image_alt_text: this.selectedApp[`screenshot_${i + 1}_alt`],
          };
          if (item.image_alt_text) slides.push(item);
        });

        return slides;
      }
      return [];
    },
  },
  data() {
    return {
      dataSrc: `${process.env.BASE_URL}data/grid-modal-data.csv`,
      appData: [],
      selectedApp: {
        app_name: '',
        year_launched: '',
        countries: '',
        type: '',
        about: '',
        adoption: '',
        implementation: '',
        features_insurance: '',
        features_investments: '',
        features_lending: '',
        features_payments: '',
        image_url: '',
        image_alttext: '',
        slides: [],
      },
    };
  },
  async mounted() {
    this.appData = await csv(this.dataSrc);
    this.appData.sort(function (a, b) {
      return a.app_name.localeCompare(b.app_name);
    });
  },
  methods: {
    handleModal(app) {
      this.selectedApp = { ...app };
      this.selectedApp.slides = this.screenshots;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-appmodalcards {
  padding: 60px 0;

  @media #{map-get($media-breakpoints, 'mobile')} {
    padding: 30px 0;
  }

  &__header {
    margin-bottom: 30px;
  }

  &__chart {
    position: relative;
    .chart-card {
      border-radius: 12px;
      border-radius: 52px;
      overflow: hidden;
      cursor: pointer;

      @media #{map-get($media-breakpoints, 'mobile')} {
        border-radius: 35px;
      }

      img {
        width: 100%;
        border-radius: inherit;
        border: 2px solid rgba(222, 222, 222, 1);
        transition: border 0.5s;
      }

      img#app-2,
      img#app-6 {
        border: 2px solid rgba(222, 222, 222, 0);
      }
    }

    .chart-card:hover {
      img {
        border: 2px solid rgba(32, 17, 19, 1);
        transition: border 0.5s;
      }

      img#app-2,
      img#app-6 {
        border: 2px solid rgba(32, 17, 19, 1);
      }
    }
  }

  .mbtm-5 {
    margin-bottom: 5px !important;
  }

  .mb-40 {
    margin-bottom: 40px;
  }

  .mb-50 {
    margin-bottom: 50px;
  }

  .modal-section {
    background: #f0f2fe;
    border-radius: 10px;
    padding: 20px;

    .features-label {
      margin-right: 15px;
    }
  }

  .modal-section--split {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 15px;

    .flex-20 {
      flex: 1 1 20%;
      @media #{map-get($media-breakpoints, 'mobile')} {
        flex: 1 1 100%;
      }
    }

    .flex-50 {
      flex: 1 1 40%;
      @media #{map-get($media-breakpoints, 'mobile')} {
        flex: 1 1 100%;
      }
    }

    .flex-half {
      flex: 1 1 40%;
      @media #{map-get($media-breakpoints, 'mobile')} {
        flex: 1 1 100%;
      }

      a,
      button {
        width: 100%;
      }
    }
  }
}

.modal-dialog {
  @media #{map-get($media-breakpoints, 'mobile')} {
    width: auto;

    .modal-body {
      padding: 0 16px;
    }
  }

  @media only screen and (min-width: #{map-get($grid-breakpoints, 'sm')}) {
    width: 760px;
  }

  width: 760px;

  .modal-nav {
    border: unset;
    display: flex;
    justify-content: start;
    margin-top: 40px;
    margin-bottom: 25px;
    position: relative;
    z-index: 5;

    p {
      color: #005EB8;
      font-weight: 700;
      font-family: "Noto Sans Bold", sans-serif;
    }
  }

  .close-button {
    top: 20x;
    right: 15px;
    font-size: 4rem;
    position: absolute;
    z-index: 5;
    color: #005EB8;
  }
}

a {
  color: #005eb8;
  text-decoration: underline !important;
  cursor: pointer;
}

.modal-dialog {
  max-width: unset;

  @media #{map-get($media-breakpoints, 'mobile')} {
    max-width: 99vw;
  }

}

</style>

<style>
.slick-slide {
    outline: none !important;
    position: relative;
}
.slick-dots {
    list-style: none;
    padding: 0;
    margin: 25px 0 0;
    text-align: center;
}
.slick-dots li {
    display: inline-block;
    padding: 0 8px;
}
.slick-dots li button {
    font-size: 0;
    line-height: 0;
    display: block;
    width: 13px;
    height: 13px;
    padding: 0;
    border: 3px solid #fff;
    border-radius: 180%;
    background: none;
}
.slick-dots li.slick-active button {
    background: #fff;
    border-color: #fff !important;
}
.slick-dots li button:hover {
    border-color: #FB002C;
}
.slick-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding: 5px;
    margin-bottom: 0;
    z-index: 9;
    background: none;
    border: 0;
    font-size: 50px;
    margin-top: -20px;
    width: 8%;
}
.slick-arrow.slick-prev {
    left: -80px;
}
.slick-arrow.slick-next {
    right: -80px;
}
</style>
